
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

const pandnPoint = [
  [],
  [20.5, 86],
  [44, 66],
  [66, 60.5],
  [63, 44],
  [11, 47],
  [18, 12.5],
  [66, 33],
];

@Options({
  data() {
    return {
      pandnPoint,
    }
  },
  computed: {
    ...mapState(['step', 'isMap'])
  },
  methods: {
    ...mapMutations(['SET_PAGE', 'SET_STEP', 'SET_ISMAP']),
    handleStart() {
      this.SET_ISMAP(true);
    },
    handleStep() {
      this.SET_PAGE(10);
    },
  }
})
export default class Map extends Vue {}
